import { IResidentTableRow } from '@/types/admin/residentList';
import { formatDateShort } from '../date';

export const RESIDENT_CSV_COLUMNS = [
  'name',
  'leaseStatus',
  'unit',
  'lastLogin',
  'lastPayment',
  'hasAutopay',
];

export const toResidentCsvRows = (rows: IResidentTableRow[]): (string | number | boolean | null)[][] => {
  const list = rows.map((row) => [
    row.name,
    row.lease_status,
    row.unit,
    formatDateShort(row.last_login),
    formatDateShort(row.last_payment),
    row.autopay,
  ]);
  return [RESIDENT_CSV_COLUMNS, ...list];
};


